import { IconButton } from "@src/appV2/redesign/components/IconButton";

interface WorkplaceReviewRemoveIconProps {
  onRemove: () => void;
}

export function WorkplaceReviewRemoveIcon(props: WorkplaceReviewRemoveIconProps) {
  const { onRemove } = props;

  return (
    <IconButton
      size="small"
      iconType="trash"
      sx={(theme) => ({
        color: theme.palette.error.main,
      })}
      variant="ghost"
      onClick={(event) => {
        event.stopPropagation();
        onRemove();
      }}
    />
  );
}
